module.exports = __webpack_public_path__ + "img/inactive-icon.6543ab86.svg";